import { render, staticRenderFns } from "./UserProfileZk.vue?vue&type=template&id=4a89729a&"
import script from "./UserProfileZk.vue?vue&type=script&lang=js&"
export * from "./UserProfileZk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports